import videojs from "../core/videojs-core.js";

let registered = false;

export function registerSkipComponents() {
  if (registered) return;
  registered = true;

  const Button = videojs.getComponent("Button");

  if (!videojs.getComponent("BackwardButton")) {
    class BackwardButton extends Button {
      constructor(player, options) {
        super(player, options);
        const seconds = Number(options?.seconds) || 10;
        this.controlText(`Back ${seconds}s`);
        this.addClass("vjs-skip-backward-button");
        this.el().innerHTML = "⏪";
      }

      handleClick() {
        const player = this.player();
        const seconds = Number(this.options_?.seconds) || 10;

        if (player.__destroying || player.isDisposed?.() || !player.el?.()) return;

        let ct = 0;
        try {
          ct = player.currentTime();
        } catch {
          return;
        }

        try {
          player.currentTime(Math.max(0, ct - seconds));
        } catch {}
      }
    }

    videojs.registerComponent("BackwardButton", BackwardButton);
  }

  if (!videojs.getComponent("ForwardButton")) {
    class ForwardButton extends Button {
      constructor(player, options) {
        super(player, options);
        const seconds = Number(options?.seconds) || 10;
        this.controlText(`Forward ${seconds}s`);
        this.addClass("vjs-skip-forward-button");
        this.el().innerHTML = "⏩";
      }

      handleClick() {
        const player = this.player();
        const seconds = Number(this.options_?.seconds) || 10;

        if (player.__destroying || player.isDisposed?.() || !player.el?.()) return;

        let ct = 0;
        let dur = 0;

        try {
          ct = player.currentTime();
        } catch {
          return;
        }

        try {
          dur = player.duration();
        } catch {
          return;
        }

        if (!isFinite(dur) || dur <= 0) return;

        try {
          player.currentTime(Math.min(dur, ct + seconds));
        } catch {}
      }
    }

    videojs.registerComponent("ForwardButton", ForwardButton);
  }
}